<template>
  <div class="liveStreaming">
    <div class="statusBar"></div>
    <div class="live_content">
      <div class="video" v-if="detailInfo.status !== 1">
        <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
        <Video id="myVideo" ref="videoPlayer" class="video-js vjs-big-play-centered" :poster="detailInfo.picUrl"></Video>
      </div>
      <div class="video" v-else>
        <img src="@/assets/images/detail/back_white.png" alt="" class="back" @click="back" />
        <img :src="detailInfo.picUrl" alt="" class="video_poster" />
      </div>
      <div class="introduction">
        <div class="d-f jc-sb ai-c">
          <span class="title">{{ detailInfo.name }}</span>
          <!-- <div class="d-f ai-c view_total"><img src="@/assets/images/detail/culturalCollection/view.png" alt="" class="icon" /> <span>123</span></div> -->
        </div>
        <div class="common_msg date d-f ai-c">
          <img src="@/assets/images/detail/performance/date.png" alt="" class="icon" />
          <span>直播时间：{{ detailInfo.startDay }} - {{ detailInfo.endDay }}</span>
        </div>
        <div class="common_msg d-f ai-c">
          <img src="@/assets/images/detail/culturalCollection/company_grey.png" alt="" class="icon" />
          <span>主办单位：{{ detailInfo.publishUnitName }}</span>
        </div>
      </div>
      <div class="content">
        <div class="title">信息简介</div>
        <div v-html="detailInfo.detail"></div>
      </div>
    </div>
    <div class="appointment_button d-f jc-sb ai-c" v-if="detailInfo.status == 1">
      <div class="d-f ai-c">
        <div class="handle_item d-f ai-c border_right" @click="share">
          <img src="@/assets/images/detail/performance/share_grey.png" alt="" class="icon_handle" />
          <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
        </div>
        <div class="handle_item d-f ai-c border_left" @click="handleFavorite">
          <img src="@/assets/images/detail/performance/zan.png" alt="" class="icon_handle" v-if="!detailInfo.isPraise" />
          <img src="@/assets/images/detail/performance/circle_zan.png" alt="" class="icon_handle" v-else />
          <span>{{ detailInfo.praiseNum }}</span>
        </div>
      </div>
      <div class="btn" @click="reserveLive" v-if="!detailInfo.isReserve">预约观看</div>
      <div class="btn" @click="cancelReserveLive" v-else>取消预约</div>
    </div>

    <div class="handle_button d-f jc-sb ai-c" v-else>
      <div class="handle_item d-f ai-c jc-c border_right" @click="share">
        <img src="@/assets/images/detail/performance/share_grey.png" alt="" class="icon_handle" />
        <span style="white-space: pre-wrap; display: inline-block; width: 30px">分享</span>
      </div>
      <div class="handle_item d-f ai-c jc-c" @click="handleFavorite">
        <img src="@/assets/images/detail/performance/zan.png" alt="" class="icon_handle" v-if="!detailInfo.isPraise" />
        <img src="@/assets/images/detail/performance/circle_zan.png" alt="" class="icon_handle" v-else />
        <span>{{ detailInfo.praiseNum }}</span>
      </div>
    </div>
    <van-share-sheet title="分享到" v-model="showShare" :options="shareOptions" />
  </div>
</template>
<script>
import videojs from 'video.js'
import 'video.js/dist/video-js.css'
import { mapGetters } from 'vuex'
import { getLiveDetails, reserveLive, cancelReserve } from '@/api/liveStreaming'
import { submitUserPraise, cancelPraise } from '@/api/operation'
import { getToken, getVenueToken } from '@/utils/auth'

export default {
  name: 'liveStreaming',
  data() {
    return {
      id: '',
      detailInfo: {},
      showShare: false,
      options: {
        autoplay: false,
        controls: true,
        preload: 'auto',
        sources: [],
        width: '100%',
        height: '100%',
        controlBar: {
          playToggle: true,
        },
      },
      testUrl: 'http://vjs.zencdn.net/v/oceans.mp4',

      mediaUrl: require('@/assets/images/detail/performance/video.mp4'), // 播放视频的路径
    }
  },
  computed: {
    ...mapGetters(['shareOptions']),
  },
  methods: {
    back() {
      this.$myUni.navigateBack({
        delta: 1,
      })
    },
    async videoInit() {
      // 初始化video.js播放器
      this.$nextTick(() => {
        this.player = videojs('myVideo', this.options)
        if (this.detailInfo.status == 2) {
          // 正在直播
          this.player.src(this.detailInfo.liveUrl)
        } else if (this.detailInfo.status == 3) {
          // 直播回放
          this.player.src(this.detailInfo.backUrl)
          // this.player.src(this.testUrl)
        } else {
          this.player.src('')
        }
        this.player.on('play', () => {
          console.log('开始播放')
        })
        this.player.on('ended', () => {
          console.log('播放完成')
        })
        // this.player.on('pause', () => {
        //   this.isPlay = false
        //   console.log('整体时长', this.player.duration())
        //   console.log('播放暂停', this.player.currentTime())
        //   if (this.player.currentTime() < this.player.duration()) {
        //     this.timeParams.duration = this.player.currentTime()
        //     this.saveProgress()
        //   }
        // })
      })
    },
    async getDetail() {
      const res = await getLiveDetails(this.id)
      this.detailInfo = res.result
      // this.detailInfo.isReserve = true
      // this.detailInfo.status = 3
    },
    handleFavorite() {
      if (!this.detailInfo.isPraise) {
        // 点赞
        submitUserPraise({ type: 5, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            this.getDetail()
          }
        })
      } else {
        // 取消点赞
        cancelPraise({ type: 5, basicId: this.id }).then((res) => {
          if (res.code == 2000) {
            this.getDetail()
          }
        })
      }
    },
    reserveLive() {
      reserveLive(this.id).then((res) => {
        if (res.code == 2000) {
          this.$cue.toast('预约成功')
          this.getDetail()
        }
      })
    },
    cancelReserveLive() {
      console.log('取消预约')
      cancelReserve(this.id).then((res) => {
        if (res.code == 2000) {
          // this.$cue.toast('预约成功')
          this.getDetail()
        }
      })
    },
    share() {
      if (getToken()) {
        this.showShare = true
      } else {
        this.$myUni.navigateTo({
          url: '/pages/login/index',
        })
      }
    },
  },
  mounted() {
    const data = JSON.parse(this.$route.query.params)
    this.id = data.id
    this.getDetail()
    setTimeout(() => {
      this.videoInit()
    }, 300)
  },
  beforeDestroy() {
    this.player.dispose()
  },
}
</script>
<style lang="scss" scoped>
.liveStreaming {
  width: 100%;
  height: 100vh;
  background: #fff;
  .statusBar {
    z-index: 10;
    position: fixed;
    top: 0;
    // top: env(safe-area-inset-top);
    left: 0;
    width: 100%;
    height: 40px;
    background: #010101;
  }
  .video {
    width: 100%;
    height: 10.55rem;
    .video_poster {
      width: 100%;
      height: 100%;
    }
    .back {
      z-index: 10;
      position: absolute;
      width: 0.6rem;
      height: 1.2rem;
      left: 0.8rem;
      top: 8px;
      // top: calc(0.5rem + env(safe-area-inset-top));
    }
    .video-player {
      width: 100%;
      height: 100%;
    }
  }
  .live_content {
    width: 100%;
    // height: calc(100% - 40px - env(safe-area-inset-top));
    height: calc(100% - 40px - 58px - env(safe-area-inset-bottom));
    position: absolute;
    // top: calc(40px + env(safe-area-inset-top));
    top: 40px;
    left: 0;
    overflow-y: auto;
  }
  .introduction {
    padding: 0.8rem 0;
    margin: 0 0.6rem;
    // border-bottom: 1px solid #f4f4f4;
    .icon {
      width: 0.7rem;
      height: 0.7rem;
      margin-right: 2px;
    }
    .title {
      font-size: 0.9rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.4rem;
    }
    .view_total {
      font-size: 0.5rem;
      color: #47988a;
      text-align: center;
      height: 0.9rem;
      line-height: 0.9rem;
      background: #dff2f2;
      border-radius: 2px;
      padding: 0 0.3rem;
    }
    .common_msg {
      font-size: 0.6rem;
      color: #666666;
      line-height: 0.8rem;
    }
    .date {
      margin: 0.6rem 0 0.3rem 0;
    }
  }
  .operation {
    padding: 0 1.65rem;
    .operation_item {
      font-size: 0.6rem;
      color: #212121;
      line-height: 0.8rem;
      .icon_operation {
        width: 1.4rem;
        height: 1.4rem;
        margin-bottom: 2px;
      }
    }
  }
  .content {
    font-size: 0.7rem;
    color: #666666;
    line-height: 1rem;
    padding: 0 0.6rem;
    .title {
      margin: 1.2rem 0 0.6rem 0;
      font-size: 1rem;
      font-weight: 600;
      color: #212121;
      line-height: 1.2rem;
    }
  }
  .handle_button,
  .appointment_button {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 2.9rem;
    width: 100%;
    background: #fff;
    padding: 0 0.6rem 0 0.6rem;
    font-size: 0.7rem;
    // color: #47988a;

    color: #212121;
    line-height: 1rem;
    padding-bottom: calc(0.6rem + env(safe-area-inset-bottom));
    .handle_item {
      &.border_right {
        padding-right: 0.6rem;
        position: relative;
        ::after {
          position: absolute;
          content: '';
          display: inline-block;
          width: 1px;
          height: 0.7rem;
          top: 0.35rem;
          right: 0;
          // background: #47988a;
          background: #212121;
        }
      }
      &.border_left {
        padding-left: 0.6rem;
      }
      .icon_handle {
        width: 1.4rem;
        height: 1.4rem;
        margin-right: 0.2rem;
      }
    }
    .btn {
      width: 50%;
      text-align: center;
      height: 1.8rem;
      line-height: 1.8rem;
      // background: #47988a;

      background: #a97048;
      border-radius: 0.9rem;
      font-size: 0.7rem;
      color: #ffffff;
    }
  }
  .handle_button {
    .handle_item {
      width: 50%;
    }
  }
}
</style>
